
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  termsModalHeading: {
    id: "TermsModal.heading",
    defaultMessage: "Terms & Conditions",
  },
	termsModalMarket: {
		id: "TermsModal.market",
		defaultMessage: "Which market do you belong to?"
	},
	termsModalSelect: {
		id: "CutOutLabelSelect.select",
		defaultMessage: "Please select"
	},
	termsModalLanguage: {
		id: "TermsModal.language",
		defaultMessage: "Please select from an available language:"
	},
});

export default MESSAGES;